import mapFunction from './mapResources';

export default mapFunction('tools_at_employees', {
    isFetching: false,
    items: [] 
});